import { render } from "./CoefficientConfigTable.vue?vue&type=template&id=dce78b50&scoped=true&ts=true"
import script from "./CoefficientConfigTable.vue?vue&type=script&lang=ts"
export * from "./CoefficientConfigTable.vue?vue&type=script&lang=ts"

import "./CoefficientConfigTable.vue?vue&type=style&index=0&id=dce78b50&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce78b50"]])

export default __exports__